/**
 * Created by Mike Naughton on 10/19/17.
 *
 * A simple editor for groups
 */

import Field from "core/models/Field";
import Group from "app/models/Group";
import FormView from "core/views/FormView";
import _ from "underscore";

export default FormView.extend({
  /**
   * Creates an editor for group models.
   * @param {Object} options The options hash
   * @param context The view context
   * @param {Group} options.model The group model to be modified
   */
  initialize: function (options) {
    FormView.prototype.initialize.call(
      this,
      _.defaults({}, options, {
        fields: this._formFields(),
        className:
          FormView.prototype.className +
          (options.model.isNew() ? " group-admin-create" : " group-admin-edit"),
      })
    );

    var model = options.model;
    var self = this;

    model.on("change:name", function () {
      model.validate(function (err, data) {
        if (err) {
          return;
        }

        var nameInput = self.inputViews["name"];

        if (nameInput) {
          nameInput.$(".help-block").remove();

          if (data.name) {
            nameInput.$el.append(
              '<span class="help-block">' + data.name + "</span>"
            );
            nameInput.$el.addClass("has-error").removeClass("has-success");
          } else {
            nameInput.$el.addClass("has-success").removeClass("has-error");
          }
        }
      });
    });
  },

  _formFields: function () {
    return [new Field(Group.fields["name"])];
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/groups/Edit.js
// module id = 931
// module chunks = 1